import { defineStore } from 'pinia';
export const useCommonStore = defineStore('commonStore', () => {
  const isAppView = ref(false as boolean);
  const previousRouteName = ref('' as string);

  function setAppViewMode (value: boolean) {
    isAppView.value = value;
  }

  function setPreviousRouteName (value: string) {
    previousRouteName.value = value;
  }

  return {
    isAppView,
    setAppViewMode,
    previousRouteName,
    setPreviousRouteName
  };
});
